/* Generated by scripts/build_wagnudge_attribution_registry.py.
 * Source SHA-256: 958cab4e0e89a54670061eae5dac041a19c94a02b97414c068f057e0f128c81f
 * Do not edit this asset directly.
 */
(function () {
  'use strict';
  var registry = {
  "registry_version": "wagnudge-attribution-registry-v1",
  "allowed_fields": [
    "source_key",
    "medium_key",
    "account_key",
    "placement_key",
    "content_key",
    "campaign_key",
    "landing_key",
    "entry_key"
  ],
  "public_entry_keys": [
    "tk_general_profile",
    "tk_bichon_profile",
    "tk_general_v001",
    "tk_bichon_v001",
    "pin_main_profile",
    "pin_main_p001"
  ],
  "short_link_plan": {
    "/tiktok": "tk_general_profile",
    "/tk-bichon": "tk_bichon_profile",
    "/tk-general-v001": "tk_general_v001",
    "/tk-bichon-v001": "tk_bichon_v001",
    "/pinterest": "pin_main_profile",
    "/pin-001": "pin_main_p001"
  },
  "referrer_rules": [
    {
      "rule_key": "google",
      "hostname_pattern": "(^|\\.)google\\.[a-z.]+$",
      "entry_key": "ref_google_organic"
    },
    {
      "rule_key": "bing",
      "hostname_pattern": "(^|\\.)bing\\.com$",
      "entry_key": "ref_bing_organic"
    },
    {
      "rule_key": "duckduckgo",
      "hostname_pattern": "(^|\\.)duckduckgo\\.com$",
      "entry_key": "ref_duckduckgo_organic"
    },
    {
      "rule_key": "yahoo",
      "hostname_pattern": "(^|\\.)search\\.yahoo\\.[a-z.]+$",
      "entry_key": "ref_yahoo_organic"
    },
    {
      "rule_key": "baidu",
      "hostname_pattern": "(^|\\.)baidu\\.com$",
      "entry_key": "ref_baidu_organic"
    }
  ],
  "fallback_entry_keys": {
    "external": "ref_other_referral",
    "same_origin_or_none": "direct_none"
  },
  "entries": {
    "tk_general_profile": {
      "source_key": "tiktok",
      "medium_key": "organic_social",
      "account_key": "tk_general",
      "placement_key": "profile",
      "content_key": "profile_link",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "tk_general_profile"
    },
    "tk_bichon_profile": {
      "source_key": "tiktok",
      "medium_key": "organic_social",
      "account_key": "tk_bichon",
      "placement_key": "profile",
      "content_key": "profile_link",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "tk_bichon_profile"
    },
    "tk_general_v001": {
      "source_key": "tiktok",
      "medium_key": "organic_social",
      "account_key": "tk_general",
      "placement_key": "video",
      "content_key": "v001",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "tk_general_v001"
    },
    "tk_bichon_v001": {
      "source_key": "tiktok",
      "medium_key": "organic_social",
      "account_key": "tk_bichon",
      "placement_key": "video",
      "content_key": "v001",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "tk_bichon_v001"
    },
    "pin_main_profile": {
      "source_key": "pinterest",
      "medium_key": "organic_social",
      "account_key": "pin_main",
      "placement_key": "profile",
      "content_key": "profile_link",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "pin_main_profile"
    },
    "pin_main_p001": {
      "source_key": "pinterest",
      "medium_key": "organic_social",
      "account_key": "pin_main",
      "placement_key": "pin",
      "content_key": "p001",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "pin_main_p001"
    },
    "ref_google_organic": {
      "source_key": "google",
      "medium_key": "organic",
      "account_key": "search_google",
      "placement_key": "referrer",
      "content_key": "organic",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "ref_google_organic"
    },
    "ref_bing_organic": {
      "source_key": "bing",
      "medium_key": "organic",
      "account_key": "search_bing",
      "placement_key": "referrer",
      "content_key": "organic",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "ref_bing_organic"
    },
    "ref_duckduckgo_organic": {
      "source_key": "duckduckgo",
      "medium_key": "organic",
      "account_key": "search_duckduckgo",
      "placement_key": "referrer",
      "content_key": "organic",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "ref_duckduckgo_organic"
    },
    "ref_yahoo_organic": {
      "source_key": "yahoo",
      "medium_key": "organic",
      "account_key": "search_yahoo",
      "placement_key": "referrer",
      "content_key": "organic",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "ref_yahoo_organic"
    },
    "ref_baidu_organic": {
      "source_key": "baidu",
      "medium_key": "organic",
      "account_key": "search_baidu",
      "placement_key": "referrer",
      "content_key": "organic",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "ref_baidu_organic"
    },
    "ref_other_referral": {
      "source_key": "other_referral",
      "medium_key": "referral",
      "account_key": "external",
      "placement_key": "referrer",
      "content_key": "referral",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "ref_other_referral"
    },
    "direct_none": {
      "source_key": "direct",
      "medium_key": "none",
      "account_key": "direct",
      "placement_key": "none",
      "content_key": "none",
      "campaign_key": "dog_breed_selector_v1",
      "landing_key": "breed_selector",
      "entry_key": "direct_none"
    }
  }
};
  function deepFreeze(value) {
    if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value;
    Object.keys(value).forEach(function (key) { deepFreeze(value[key]); });
    return Object.freeze(value);
  }
  window.WAGNUDGE_ATTRIBUTION_REGISTRY_V1 = deepFreeze(registry);
})();
